import "../style.css";

function UpperTextRightAnchor({ text, text2, posx, posy, fontSize, textColor = "white" }) {
  return (
    <div
      className="container-component-upper-text"
      style={{ top: `${posy}%`, right: `${posx}%`, position: "absolute", zIndex: 1000 }}
    >
      <span className="unit overlay-text-font" style={{ fontSize: fontSize, color: textColor }}>
        {text}
      </span>
      <br />
      <span className="unit overlay-text-font" style={{ fontSize: fontSize, color: textColor }}>
        {text2}
      </span>
    </div>
  );
}

export default UpperTextRightAnchor;
